<script setup>
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {usePersonal} from "@/features/personal/composables/usePersonal";

const route = useRoute()
const router = useRouter()

const {refreshUserInfo} = usePersonal();

onMounted(async () => {
  const token = route.query.token

  if (!token || typeof token !== 'string') {
    await router.replace('/auth')
    return
  }

  await localStorage.setItem('token', token)
  await refreshUserInfo();
  await router.replace('/dashboard')
})
</script>